/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserWithRelations } from './userWithRelations';


/**
 * (tsType: VacationRequestWithRelations, schemaOptions: { includeRelations: true })
 */
export interface VacationRequestWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    userId: number;
    /**
     * The code
     */
    code?: string;
    startDate: string;
    endDate: string;
    totalDays: number;
    selectedDates?: Array<string>;
    status?: VacationRequestWithRelations.StatusEnum;
    approverBossId?: number;
    approvedByBossAt?: string;
    bossComments?: string;
    payrollApproverId?: number;
    approvedByPayrollAt?: string;
    payrollComments?: string;
    manualApproverId?: number;
    manualApproverReason?: string;
    rejectedById?: number;
    rejectedAt?: string;
    rejectionReason?: string;
    cancelledAt?: string;
    cancellationReason?: string;
    employeeComments?: string;
    balanceSnapshot?: object;
    hrNotified?: boolean;
    hrNotifiedAt?: string;
    notifyStartOn?: string;
    notifyEndOn?: string;
    crossesAnniversary?: boolean;
    daysInCurrentPeriod?: number;
    daysInNextPeriod?: number;
    isAdvance?: boolean;
    advanceDays?: number;
    advanceReason?: string;
    advanceAuthorizedBy?: number;
    advanceAuthorizedOn?: string;
    user?: UserWithRelations;
    approverBoss?: UserWithRelations;
    payrollApprover?: UserWithRelations;
    manualApprover?: UserWithRelations;
    rejectedBy?: UserWithRelations;
}
export namespace VacationRequestWithRelations {
    export type StatusEnum = 'draft' | 'pending' | 'approved_by_boss' | 'pending_payroll' | 'approved_by_payroll' | 'rejected' | 'cancelled' | 'completed';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Pending: 'pending' as StatusEnum,
        ApprovedByBoss: 'approved_by_boss' as StatusEnum,
        PendingPayroll: 'pending_payroll' as StatusEnum,
        ApprovedByPayroll: 'approved_by_payroll' as StatusEnum,
        Rejected: 'rejected' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum,
        Completed: 'completed' as StatusEnum
    };
}


